import { PureJsonErrorType } from '@signal/utils/types'
import {
  DataMiddlewareType,
  ErrorWithResponseType,
  ResponseOrErrorType,
  ShowToastrType
} from './types'

// this middleware shows toasts on failure (or success, optionally)
const toastrMiddleware = ({
  showToastr,
  fetchContext,
  showSuccessToast = true
}: {
  showToastr: ShowToastrType
  fetchContext?: string
  showSuccessToast?: boolean
}): DataMiddlewareType => async (
  respOrError?: ResponseOrErrorType
): Promise<ResponseOrErrorType> => {
  if (
    respOrError instanceof Error &&
    (respOrError as ErrorWithResponseType).response
  ) {
    respOrError = respOrError as ErrorWithResponseType
    let errorMessage = respOrError.message || respOrError.response.statusText
    respOrError.response
      .json()
      .then(({ error }: PureJsonErrorType) => {
        if (error && error.message) {
          errorMessage = error.message
        }
      })
      .catch(() => {})
      .finally(() => {
        showToastr({
          severity: 'error',
          text: `${fetchContext} error: ${errorMessage}`
        })
      })
  } else if (fetchContext && showSuccessToast) {
    showToastr({
      severity: 'success',
      text: `${fetchContext} completed successfully.`
    })
  }
  return respOrError
}

export default toastrMiddleware
